import { combineTokens } from '@utils/css';

const tokens = combineTokens("--image-media", {
  width: "10000px",
  height: "10000px",
  aspect: "16 / 9"
});
const modal = "_35sm1xtalk7";
const imageWrapper = "_35si5ko9cc";
const contextMenu = "_35sc1c8wias";
const image = "_35sinwece0";

export { contextMenu, image, imageWrapper, modal, tokens };
import "./image.style.linaria.module.css";
//# sourceMappingURL=image.style.js.map
